/* eslint-disable react/no-danger */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ButtonComponent from '@/components/Button';
import { ROUTES } from '@/constants';
import TransactionsSection from './Sections/Transactions';
import ChartSection from './Sections/Chart';
import CreditSummary from './CreditSummary';

import './index.scss';

function DashboardContainer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="dashboard-container">
      <div className="summary-wrap">
        <CreditSummary />
        <div className="card subscription-container">
          <div className="card-title">
            {t('dashboard.summary_section.subscription.title')}
          </div>
          <div
            className="card-description"
            dangerouslySetInnerHTML={{
              __html: t('dashboard.summary_section.subscription.description'),
            }}
          />
          <div className="btn-explore">
            <ButtonComponent
              type="primary"
              onClick={() => navigate(ROUTES.SUBSCRIPTIONS.INDEX)}
            >
              {t('dashboard.summary_section.subscription.btn_text')}
            </ButtonComponent>
          </div>
        </div>
        <div className="card new-branding-container">
          <div className="card-title">
            {t('dashboard.summary_section.new_branding.title')}
          </div>
          <div
            className="card-description"
            dangerouslySetInnerHTML={{
              __html: t('dashboard.summary_section.new_branding.description'),
            }}
          />
          <div className="btn-explore">
            <ButtonComponent
              type="primary"
              onClick={() => navigate(ROUTES.SMS.INDEX)}
            >
              {t('dashboard.summary_section.new_branding.btn_text')}
            </ButtonComponent>
          </div>
        </div>
      </div>
      <ChartSection />
      <TransactionsSection />
    </div>
  );
}

export default DashboardContainer;
